import { useCallback, useRef, useState, SetStateAction, Dispatch } from 'react';
const isFunction: any = (setStateAction: any) => typeof setStateAction === 'function';
const useStateRef = (initialState: any) => {
  const [state, setState] = useState(initialState);
  const ref = useRef(state);

  const dispatch = useCallback((setStateAction: any) => {
    ref.current = isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;
    setState(ref.current);
  }, []);

  return [state, dispatch, ref];
};
export default useStateRef;
